import { jsx as _jsx } from "react/jsx-runtime";
import { useAetherLabels } from '#pplx/frontend/aether/internal/labels/useAetherLabels.js';
import React from 'react';
const VARIANT_CONFIG = {
    education: { viewBox: '0 0 348 55', href: '#pplx-logo-word-edu-pro', label: 'logoEducationPro' },
    computer: {
        viewBox: '0 0 595 64',
        href: '#pplx-logo-word-computer',
        label: 'logoPerplexityComputer',
    },
    'enterprise-pro': {
        viewBox: '0 0 528 78',
        href: '#pplx-logo-word-ent-pro',
        label: 'logoEnterprisePro',
    },
    'enterprise-max': {
        viewBox: '0 0 567 78',
        href: '#pplx-logo-word-ent-max',
        label: 'logoEnterpriseMax',
    },
    enterprise: {
        viewBox: '0 0 786 82',
        href: '#pplx-logo-word-ent',
        label: 'logoEnterprise',
        fill: 'none',
    },
    pro: { viewBox: '0 0 654 101', href: '#pplx-logo-word-pro', label: 'logoPerplexityPro' },
    max: { viewBox: '0 0 701 100', href: '#pplx-logo-word-max', label: 'logoPerplexityMax' },
    perplexity: {
        viewBox: '0 0 962 202',
        href: '#pplx-logo-word',
        label: 'logoPerplexity',
        fill: 'none',
    },
};
export const Word = React.memo(function Word({ variant = 'perplexity', ...divProps }) {
    const labels = useAetherLabels();
    const config = VARIANT_CONFIG[variant];
    return (_jsx("div", { ...divProps, children: _jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: config.viewBox, fill: config.fill, role: "img", "aria-label": labels[config.label], children: _jsx("use", { href: config.href }) }) }));
});
//# sourceMappingURL=Word.js.map